<template>
  <div class="main" :style="{'minHeight': mainHeight}">

<!--    <div style="margin-top: 25%;color: white; font-size: 24px">Still working one it. we'll be back soon.</div>-->

  </div>
</template>

<script>
export default {
  name: 'wind',
  data () {
    return {
      mainHeight: 0
    }
  },
  mounted () {
    this.$nextTick(() => {
      var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

      var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

      this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')

      window.addEventListener('resize', function () {
        var wheight = (window.innerHeight) ? window.innerHeight : (document.documentElement && document.documentElement.clientHeight) ? document.documentElement.clientHeight : document.body.offsetHeight

        var scrollHeight = (document.documentElement) ? document.documentElement.scrollTop : document.body.scrollTop

        this.$set(this.$data, 'mainHeight', wheight + scrollHeight - 102 - 48 + 'px')
      }.bind(this))
    })
  }
}
</script>

<style scoped>
  .main {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("../../static/img/bg.png") no-repeat;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/wind.vue